<template>
  <div>
    <CAlert show color="danger" v-if="tokens <= 0">Tu paquete de eventos (tokens) se ha agotado, si deseas registrar nuevos eventos necesitas contratar un paquete adicional.</CAlert>
    <CAlert show color="danger" v-if="deadline <= 0">La vigencia de tu paquete de eventos (tokens) ha terminado, si deseas registrar nuevos eventos necesitas contratar un paquete adicional.</CAlert>
  <CCard >
    <CCardHeader>
      <slot name="header">
        <CIcon name="cil-layers"/> {{caption}}
        <div class="card-header-actions">
          <CRow>        
            <CCol md="12" style="display:flex;"> 
              <div role="group" class="form-group">               
                <CButton color="success" style="color: #fff" size="sm"  @click="downloadExcel()">Exportar Listado Excel</CButton>
                <CButton color="info" size="sm" @click="storeModal()" v-if="deadline > 0 && tokens > 0">Nuevo Evento</CButton>
              </div>          
            </CCol>
          </CRow>
        </div>
      </slot>
    </CCardHeader>
    <CCardBody>
      <CRow>        
        <CCol md="12">
          <!-- FILTROS -->
          <CRow>
            <CCol md="3">
                <div role="group" class="form-group" style="margin: -10px 0px 10px">
                  <label> Fecha:</label>
                  <v-date-picker                    
                    v-model="range"    
                    class="date-picker"
                    locale="es-MX" size="sm"          
                    mode="range"
                    :popover="{ visibility: 'click' }"
                  />        
                </div>
              </CCol>
            <CCol md="2">
              <div role="group" class="form-group" style="margin: -10px 0px 10px">
                <label>Clase:</label>
                <CSelect
                  :value.sync="classSelect" 
                  :options="classesOptions"
                  @change="changeFilters"
                />                        
              </div>
            </CCol>
            <CCol md="2">
              <div role="group" class="form-group" style="margin: -10px 0px 10px">
                <label>Estado:</label>
                <CSelect
                  :value.sync="statusSelect" 
                  :options="statusOptions"
                  @change="changeFilters"
                />                        
              </div>
            </CCol>                    
          </CRow>     
        </CCol>
      </CRow>
      <CRow>
        <CCol md="12" style="font-size: 14px;">
          <CDataTable
            :hover="hover"
            :striped="striped"
            :border="border"
            :small="small"
            :fixed="fixed"
            :items="items"
            :fields="fields"
            :items-per-page="small ? 30 : 50"
            :dark="dark"
            :sorter="{ external: false, resetable: true }"
            pagination
            :table-filter="{label: 'Buscar: ', placeholder: '...'}"
            :noItemsView="{ noResults: 'No se encontraron elementos', noItems: 'Sin Invitados' }"
          >
            <template #code="{item}"><td class="text-center">{{item.code}}</td></template>
            <template #date="{item}">
              <td class="text-center">
                {{item.date | date}}
                <br>
                <template v-if="item.start_hour != '' || item.end_hour != ''">
                  <span style="font-size: 10px;">
                    <strong>{{ item.start_hour }}/{{ item.end_hour }}</strong>
                  </span>                  
                </template>                
              </td>
            </template>
            <template #last_confirm_date="{item}">
              <td class="text-center">
                {{item.last_confirm_date | date}}                      
              </td>
            </template>            
            <template #class="{item}"><td class="text-left" style="font-size: 12px;">{{item.class_name}}</td></template>
            <template #name="{item}"><td class="text-left" style="font-size: 12px;"><b style="font-size: 14px;">{{item.name}}</b><br /><span style="font-size: 12px;">{{item.description}}</span><span v-if="item.address"><br />{{item.address}}</span></td></template>
            <template #responsable="{item}">
              <td class="text-left" style="font-size: 12px;">
                <strong style="font-size: 13px;">{{ item.planner_name || '-' }}</strong>
                <template v-if="item.planner_email">
                  <br>
                  <span>{{ item.planner_email }}</span>
                </template>
                <template v-if="item.planner_phone">
                  <br>
                  <span>{{ item.planner_phone }}</span>
                </template>
              </td>
            </template>
            <template #stats="{item}">
              <td class="text-center" style="font-size: 12px;">
                <div><strong>Mesas:</strong> {{ item.num_tables > 0 ? item.num_tables : '-' }}</div>
                <div><strong>Invitados:</strong> {{ item.tickets }}</div>
                <div><strong>Conf. Invitaciones:</strong> {{ item.percent_confirm }}%</div>
                <div><strong>Conf. Invitados:</strong> {{ item.percent_tickets_confirm }}%</div>
              </td>
            </template>
            <template #status="{item}">
              <td class="text-center" style="font-size: 16px;">
                <template v-if="item.status_code == 'open'">
                  <CBadge color="warning">{{item.status_name}}</CBadge>
                </template>
                <template v-else-if="item.status_code == 'done'">
                  <CBadge color="success">{{item.status_name}}</CBadge>
                </template>
                <template v-else-if="item.status_code == 'canceled'">
                  <CBadge color="danger">{{item.status_name}}</CBadge>
                </template>
                <template v-else>
                  <CBadge color="info">{{item.status_name}}</CBadge>
                </template>                
              </td>
            </template>
            <template #actions="{item}">
              <td style="padding: 0px; padding-bottom: 2px;" class="table_actions text-center">
                <CButton v-if="item.is_active" color="warning" style="color: #fff" size="sm" @click="updateModal(item)"><CIcon name="cil-pencil"/></CButton>                
                <CButton color="dark" size="sm"  @click="deleteModal(item)"><CIcon name="cil-trash"/></CButton>
                <table style="padding: 0px; margin: auto; ">
                  <tr>
                    <td style="padding: 0px; border: 0px !important;">
                      <CButton color="info" size="sm" :to="{ name: 'event-detail', params: { id: item.id } }">Invitados</CButton>
                    </td>
                    <td style="padding: 0px; border: 0px !important;">
                      <CDropdown color="info" togglerText="" size="sm">
                        <CDropdownItem href="#" v-if="item.is_active" @click="addGuestModal(item)">Nuevo Invitados</CDropdownItem>
                        <CDropdownItem href="#" v-if="item.is_active" @click="importGuestsModal(item)">Importar Invitados</CDropdownItem>
                        <template v-if="item.image != ''">
                          <CDropdownDivider/>         
                          <CDropdownItem :href="item.image" target="_blank" v-if="item.is_active">Ver Invitación</CDropdownItem>
                        </template>                        
                      </CDropdown>
                    </td>
                  </tr>
                </table>
              </td>
            </template>
          </CDataTable>
        </CCol>
      </CRow>
    </CCardBody>
    <EventModal ref="addModal" @store="storeProcess" @update="updateProcess"></EventModal>
    <GuestModal ref="addGuestModal" @store="storeProcess"></GuestModal>
    <ImportGuestsModal ref="importModal" @refresh="changeFilters"></ImportGuestsModal>
    <DeleteModal ref="deleteModal" @confirm="deleteProcess"></DeleteModal>
  </CCard>
  </div>
</template>

<script>
import EventModal from '@/components/events/EventModal.vue';
import GuestModal from '@/components/events/event/detail/guests/GuestModal.vue';
import ImportGuestsModal from '@/components/events/event/detail/guests/ImportGuestsModal.vue';
import DeleteModal from '@/components/global/ConfirmModal.vue';
import ws_class from '@/services/events_classes';
import ws_status from '@/services/events_status';
import ws from '@/services/events';
import ws_account from '@/services/account';
import store from '@/store'
import moment from 'moment';
import { DatePicker } from 'v-calendar'

export default {
  name: 'EventsGeneralTable',
  components: {
    EventModal,
    DeleteModal,
    GuestModal,
    ImportGuestsModal,
    'v-date-picker': DatePicker
   },
  props: {
    items: Array,
    permissions: Array,
    fields: {
      type: Array,
      default () {
        return [
          {key: 'code', label: 'Código', _style:"width: 50px;", sorter: true},
          {key: 'date', label: 'Fecha', _style:"width: 100px;", sorter: true},
          {key: 'name', label: 'Nombre', sorter: true},
          {key: 'class', label: 'Clase', _style:"width: 100px;", sorter: false},
          {key: 'responsable', label: 'Responsable', _style:"width: 180px;", sorter: false},
          {key: 'last_confirm_date', label: 'Fecha Limite Confirmación' ,_style:"width: 110px;", sorter: true},
          {key: 'stats', label: 'Resumen', _style:"width: 180px;", sorter: false},
          {key: 'status', label: 'Estado',_style:"width: 75px;", sorter: false},
          {key: 'actions', label: 'Acciones', class: 'actions', sorter: false },
        ]
      }
    },
    caption: {
      type: String,
      default: 'Table'
    },
    hover: Boolean,
    striped: Boolean,
    border: Boolean,
    small: Boolean,
    fixed: Boolean,
    dark: Boolean
  },
  data() {
    return {
      toasts: [],
      idToDelete: "",
      moduleDelete: "",
      statusSelect: "",
      classSelect: "",
      classesOptions: [],
      statusOptions: [],
      range: {
        start: new moment().startOf('month').subtract(1, 'months').toDate(),
        end: new moment().endOf("month").add(11, 'months').toDate(),
      },
      deadline: 1,
      tokens: 1
    }
  },
  mounted: async function() {
    this.loading();

    let response_class = await ws_class.get();
    if(response_class.type == "success"){
      this.classesOptions = await this.$parseSelectOptionsOrdered(response_class.data, "id", "name",[{"label": "Todos","value":""}]);
    }
    let response_status = await ws_status.get();
    if(response_status.type == "success"){
      const openStatus = response_status.data.find((line) => (line.code || '').toLowerCase() === 'open');
      this.statusSelect = openStatus ? openStatus.id : "";
      this.statusOptions = await this.$parseSelectOptionsOrdered(response_status.data, "id", "name",[{"label": "Todos","value":""}]);
    }

    let response_account = await ws_account.getInfo();
    if(response_account.type == "success"){
      this.tokens = response_account.data.tokens;
      this.deadline = response_account.data.deadline_days;
    }

    await this.changeFilters();

    this.loaded();
  },
  methods: {
    async downloadExcel(){
      this.loading();

      let filters = this.getFilters();
      await ws.downloadExcel(filters);
      
      this.loaded();
    },
    async changeFilters () {
      let filters = this.getFilters();
      this.$emit("refreshItems", filters);
    },
    getFilters(){
      let filters = {
        date : [moment(this.range.start).format("YYYY-MM-DD"),moment(this.range.end).format("YYYY-MM-DD")],
        event_status_id: this.statusSelect,
        event_class_id: this.classSelect,
      };

      return filters;
    },
    addGuestModal (item) {
      this.$refs.addGuestModal.storeModal(item.id);
    },
    importGuestsModal (item) {
      this.$refs.importModal.importExcelModal(item.id);
    },
    storeModal () {
      this.$refs.addModal.storeModal();
    },
    updateModal (item) {
      this.$refs.addModal.updateModal(item);
    },
    assignModal (item) {
      this.$refs.assignModal.storeModal(item);
    },
    unassignModal (item) {    
      this.idToDelete = item.id;
      this.moduleDelete = "unassign";
      let color = "warning";
      let title = "Desasignar Persona";
      let content = "Esta seguro que quiere desasignar a " +item.person+" del siguiente activo?"
      let confirm = item.code + " - " + item.name
      this.$refs.deleteModal.show(color,title,content,confirm);
    },  
    deleteModal (item) {    
      this.idToDelete = item.id;
      this.moduleDelete = "delete";
      let color = "danger";
      let title = "Eliminar Evento";
      let content = "¿Estás seguro que deseas eliminar el evento?"
      let confirm = "<span style='font-size: 16px;font-weight: bold;'>"+item.code + " - " + item.name+"</span><br /><span style='font-size: 14px;'>"+item.description+"</span>";
      this.$refs.deleteModal.show(color,title,content,confirm);
    },        
    async storeProcess(data) {
      this.loading();
      let response = await ws.store(data);      
      if(response.type == "success"){
        this.$emit("refreshItems",this.getFilters());
      }

      this.showToast(response.type, response.message);
      this.loaded();
    },
    async updateProcess(data) {
      this.loading();
      let response = await ws.update(data);

      if(response.type == "success"){
        this.$emit("refreshItems",this.getFilters());
      }

      this.showToast(response.type, response.message);
      this.loaded();
    },
    async deleteProcess() {
      this.loading();
      let response = "";
      if(this.moduleDelete == "delete"){
        response = await ws.delete({id: this.idToDelete});            
      }else{
        response = await ws_assig.unassign({id: this.idToDelete});
      }

      if(response.type == "success"){
        this.$emit("refreshItems",this.getFilters());
      }      

      this.showToast(response.type, response.message);
      this.loaded();
    },
    showToast(type, message){
      store.commit('toast', {color: type, message: message});
    },
    loading(){
      store.commit('loading');
    },
    loaded(){
      store.commit('loaded');
    }
  },
  watch: {
    range: async function(){
      await this.changeFilters();
    }
  },
}
</script>
